/* import __COLOCATED_TEMPLATE__ from './sq-radio.hbs'; */
/**
An Atomic Radio Button

This component is meant to be used without a label, such as as a column in a table. If you
need a radio button with a label, see the [sq-option-radio](./sq-option-radio.html) component.

```example
@title Basic Usage
@description

@hbs
<p>Default<p>
{{sq-radio}}

<p>Selected<p>
{{sq-radio selected=true}}

<p>Default Disabled<p>
{{sq-radio disabled=true}}

<p>Selected Disabled<p>
{{sq-radio selected=true disabled=true}}

```
@param {String} optionName - A name for this option.
@param {String} fieldName - A name for the set that this radio button belongs to.
@param {Any} value - A value that this radio button represents **NOTE:** This param is not to be used to reprenset the radio button's state (e.g. a boolean representing the button's selected state). Use the `selected` param instead.
@param {Boolean} [selected=false] - Whether or not this radio button is initially selected
@param {Boolean} [disabled=false] - Disable the radio button
@param {Number} [tabindex=0] - passes through to the input giving it a tabindex for keyboard navigation
@param {Function} action - An action to perform when the value of 'selected' changes. Is passed the new 'selected' value of the radio button
*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'span',
  classNames: ['option-toggle', 'radio'],
  classNameBindings: ['selected:option-toggle--is-selected', 'selected:radio--is-selected', 'disabled:option-toggle--is-disabled', 'disabled:radio--is-disabled'],
  attributeBindings: ['data-test-radio', 'data-test-radio-selected'],
  'data-test-radio': computed('value', function () {
    return this.get('value') || true;
  }),
  'data-test-radio-selected': readOnly('selected'),
  selected: false,
  // The input element is invisible and positioned over top of
  // this parent element, so it should receive all click events
  // and will call this function in it's onChange event
  actions: {
    onChange(selected) {
      if (this.action) {
        this.action(this.get('value'), selected, this.get('optionName'));
      }
      this.set('selected', selected);
    }
  }
});